import styled from "styled-components";

type Size = "xs" | "sm" | "md" | "lg";

const spacing = (size?: Size) => {
  switch (size) {
    case "lg":
      return "2rem";
    case "sm":
      return "1rem";
    case "xs":
      return "0.5rem";
    case "md":
    default:
      return "1.5rem";
  }
};

const Divider = styled.hr<{ size?: Size }>`
  margin-top: ${({ size }) => spacing(size)};
  margin-bottom: ${({ size }) => spacing(size)};
  border-top: 1px solid ${({ theme }) => theme.colors.gray200};
`;

export default Divider;
